import { ensureDefined, trimToNullRecursively, } from '@tymia/shared';
export function nonEmptyString() {
    return {
        type: 'string',
        minLength: 1,
    };
}
export function nullableString(props) {
    return {
        type: ['string', 'null'],
        nullable: true,
        ...props,
    };
}
export function nullableNonEmptyString() {
    return {
        type: ['string', 'null'],
        nullable: true,
        minLength: 1,
    };
}
export function nullableNumber(props) {
    return {
        type: ['number', 'null'],
        nullable: true,
        ...props,
    };
}
export function nonNullableBoolean() {
    return {
        type: 'boolean',
    };
}
export function nullableBoolean() {
    return {
        type: ['boolean', 'null'],
        nullable: true,
    };
}
export function nullableNonEmptyEmail() {
    return {
        type: ['string', 'null'],
        format: 'idn-email',
        nullable: true,
        minLength: 1,
    };
}
export function nonEmptyEmail() {
    return {
        type: 'string',
        format: 'idn-email',
        minLength: 1,
    };
}
export function nullableEnum(values) {
    return {
        type: ['string', 'null'],
        enum: [...values, null],
        nullable: true,
    };
}
export function validateCompiled(validator, props) {
    const trimmed = trimToNullRecursively(props);
    const result = validator(trimmed);
    if (result) {
        return [true, trimmed];
    }
    return [false, ensureDefined(validator.errors)];
}
export const pagingRequest = {
    properties: {
        page: {
            type: 'number',
            minimum: 1,
        },
        limit: {
            type: 'number',
            minimum: 1,
            maximum: 100,
        },
    },
};
export const pagingResponse = {
    properties: {
        limit: {
            type: 'number',
            minimum: 1,
        },
        count: {
            type: 'number',
            minimum: 0,
        },
        page: {
            type: 'number',
            minimum: 1,
        },
        pages: {
            type: 'number',
            minimum: 0,
        },
    },
    required: [
        'limit',
        'count',
        'page',
        'pages',
    ],
};
export function pagedSchema(schema) {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            list: {
                type: 'array',
                items: schema,
                uniqueItems: true,
            },
            limit: {
                type: 'number',
                minimum: 1,
            },
            count: {
                type: 'number',
                minimum: 0,
            },
            page: {
                type: 'number',
                minimum: 1,
            },
            pages: {
                type: 'number',
                minimum: 0,
            },
        },
        required: [
            'list',
            'limit',
            'count',
            'page',
            'pages',
        ],
    };
}
/** @deprecated use pagedSchema */
export function pagedSchemaOld(schema) {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            list: {
                type: 'array',
                items: schema,
                uniqueItems: true,
            },
            limit: {
                type: 'number',
                minimum: 1,
            },
            maxItems: {
                type: 'number',
                minimum: 0,
            },
            currentPage: {
                type: 'number',
                minimum: 1,
            },
            pages: {
                type: 'number',
                minimum: 0,
            },
        },
        required: [
            'list',
            'limit',
            'maxItems',
            'currentPage',
            'pages',
        ],
    };
}
//# sourceMappingURL=validator.js.map